import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Link,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  SvgIcon,
  makeStyles,
  Grid,
  colors,
  Avatar,
  Icon,
  Typography,
  Button
} from '@material-ui/core';

import { Search as SearchIcon } from 'react-feather';
import { RiEqualizerLine } from "react-icons/ri";
import Add from '@material-ui/icons/AddCircleOutline';

const useStyles = makeStyles((theme) => ({
  root: {

  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200],
    width: 58,
    height: 58
  },
  iconoperation: {
    width: 45,
    height: 45
  },
  baroperation: {
    width: '100%',
    minHeight: 65
  }
}));

const Toolbar = ({ item, openEdition }) => {

  const classes = useStyles();

  return (
    <Fragment>
      <Box className={classes.baroperation}>

        <Grid container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item
            md="auto"
            xs="auto">
            <Avatar variant="rounded"
              className={classes.avatar}
            >
              {<Icon className={classes.iconoperation} component={RiEqualizerLine} style={{ color: colors.indigo[400] }} ></Icon>}
            </Avatar>

          </Grid>
          <Grid item
            md="auto"
            xs="auto">
            <Typography
              color="primary"
              variant="h5"
            >
              Você esta na área de <b>{<Link color="inherit" href="/cfg/main">CONFIGURAÇÃO</Link>}</b>. A operação padrão é <b> {localStorage.getItem('company')}</b>
            </Typography>

            <Typography
              color="secondary"
              variant="h4"
            >
              <b>Configurações Gerais</b>
            </Typography>

          </Grid>
        </Grid>
      </Box>

      <Box>
        <Card>
          <CardContent>
            <Grid container
              fullWidth
              direction="row"
              justify="flex-start"
              alignItems="flex-end"
            >
              <Grid item
                xs={6}
              >
                <Box maxWidth={500}>
                  <TextField
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                          >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    placeholder="Buscar Configuração Geral"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                  />
                </Box>
              </Grid>
              <Grid item
                xs={6}
              >
                <Grid container
                  fullWidth
                  direction="row"
                  justify="flex-end"
                  alignItems="flex-end"
                >
                  <Grid item
                    md="auto"
                    xs="auto"
                  >
                    <Box mt={2}>
                      <Button
                        color="secondary"
                        size="small"
                        disabled
                        variant="contained"
                        startIcon={<Add />}
                        onClick={() => { openEdition(item) }}>
                        Criar Configuração
                      </Button>
                    </Box>
                  </Grid>

                </Grid>

              </Grid>

            </Grid>

          </CardContent>
        </Card>
      </Box>
    </Fragment>

  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
